import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const BestOddsWidgetAsyncComponent = AsyncComponent(async () => import('./best-odds-widget' /* webpackChunkName: "best-odds-widget" */ ));

export const BestOddsWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper isMandatory={!props.isPreview}>
    <React.Suspense fallback={<div/>}>
      <BestOddsWidgetAsyncComponent {...props}/>
    </React.Suspense>
  </ErrorBoundaryWrapper>
};
